(() => {
  if (window.BWGreetingCardUpsellInit) {
    return;
  }
  window.BWGreetingCardUpsellInit = true;

  const cartAddUrl =
    window.theme && window.theme.routes && window.theme.routes.cartAdd
      ? window.theme.routes.cartAdd
      : '/cart/add.js';
  const cartUpdateUrl =
    window.theme && window.theme.routes && window.theme.routes.cartUpdate
      ? window.theme.routes.cartUpdate
      : '/cart/update.js';

  const dispatchCartChange = () => {
    document.dispatchEvent(
      new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
    );
  };

  const refreshCartDrawer = () => {
    document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true,
        cancelable: false,
      })
    );
  };

  const setRootLoading = (root, isLoading) => {
    root.classList.toggle('is-loading', isLoading);
    root.querySelectorAll('button, input').forEach((el) => {
      el.disabled = isLoading;
    });
  };

  const getRoot = (target) => target.closest('[data-greeting-card-root]');

  const isGreetingCardItem = (cartItem) => {
    const props = cartItem && cartItem.properties ? cartItem.properties : {};
    const isGreetingCard = String(props._greeting_card || '').toLowerCase() === 'true';
    const isGreetingCardTypo = String(props._gerrting_card || '').toLowerCase() === 'true';
    return isGreetingCard || isGreetingCardTypo;
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });
    return response.json();
  };

  const removeGreetingCardItems = async () => {
    const cart = await fetchCart();
    const updates = {};

    (cart.items || []).forEach((cartItem) => {
      if (isGreetingCardItem(cartItem)) {
        updates[cartItem.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      return;
    }

    await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ updates }),
    });
  };

  const addGreetingCardItem = async (variantId) => {
    const numericVariantId = Number(variantId);
    if (!numericVariantId) {
      return;
    }

    await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [
          {
            id: numericVariantId,
            quantity: 1,
            properties: {
              _greeting_card: 'true',
            },
          },
        ],
      }),
    });
  };

  const setActiveOption = (root, variantId) => {
    root.querySelectorAll('[data-greeting-card-option]').forEach((el) => {
      const isActive = String(el.dataset.variantId) === String(variantId);
      el.classList.toggle('is-active', isActive);
      el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const setSelectedState = (root, variantId, title) => {
    root.dataset.selectedVariantId = String(variantId || '');
    root.classList.toggle('is-selected', !!variantId);

    const selectedEl = root.querySelector('[data-greeting-card-selected]');
    if (!selectedEl) return;

    if (!variantId) {
      selectedEl.remove();
      return;
    }

    selectedEl.textContent = `Ausgewahlt: ${title || ''}`;
  };

  const ensureSingleGreetingCard = async (root, variantId, title) => {
    await removeGreetingCardItems();
    await addGreetingCardItem(variantId);
    setSelectedState(root, variantId, title);
  };

  document.addEventListener('click', (evt) => {
    const toggleRow = evt.target.closest('[data-greeting-card-toggle-row]');
    if (!toggleRow) return;

    const root = getRoot(toggleRow);
    if (!root) return;

    const panel = root.querySelector('[data-greeting-card-panel]');
    if (!panel) return;

    panel.hidden = !panel.hidden;
    root.querySelector('[data-greeting-card-icon-toggle]')?.setAttribute('aria-expanded', String(!panel.hidden));
  });

  document.addEventListener('click', async (evt) => {
    const optionBtn = evt.target.closest('[data-greeting-card-option]');
    if (!optionBtn) return;

    const root = getRoot(optionBtn);
    if (!root) return;

    const panel = root.querySelector('[data-greeting-card-panel]');
    const variantId = String(optionBtn.dataset.variantId || '').trim();
    const title = String(optionBtn.dataset.variantTitle || '').trim();

    if (!variantId) return;

    evt.preventDefault();

    try {
      setRootLoading(root, true);
      setActiveOption(root, variantId);
      await ensureSingleGreetingCard(root, variantId, title);
      if (panel) panel.hidden = true;
      dispatchCartChange();
      refreshCartDrawer();
    } catch (error) {
      // Ignore and rely on cart refreshes for visual recovery.
    } finally {
      setRootLoading(root, false);
    }
  });
})();
